import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles(() => ({
  paperStyle: {
    height: '100%',
    width: '100%',
    maxWidth: '100%',
  },
}));
